import { BeeswaxReportProperties } from '@/Enums/Report/BeeswaxReportProperties.enum';
import { BASE_MAP_SCALES } from '@/constants/geo';

export const getZipCodesForRequest = zipData => {
  if (!zipData?.length) return;
  return zipData
    .filter(obj => obj[BeeswaxReportProperties.GEO_ZIP])
    .sort((a, b) => b.Value - a.Value)
    .map(obj => obj[BeeswaxReportProperties.GEO_ZIP])
    .slice(0, 100);
};

// Dedupe before slicing: the per-row reports often include the same geo id
// many times (one row per zip × campaign for a single CD, etc.), so a raw
// `.slice(0, limit)` can leave many polygons unrendered even when the boundary
// table has them — the user sees the geo map "sometimes inconsistent" instead
// of the partial coverage being explained by data shape.
const dedupeAndCap = (ids, limit) => [...new Set(ids)].slice(0, limit);

export const getBoundariesRequestBody = (mapScale, geoData, fieldName, limit = 100) => {
  if (!geoData?.length) return;
  return {
    mapScale,
    geoIds: dedupeAndCap(
      geoData.filter(obj => obj[fieldName] && obj[fieldName] !== 'Unknown').map(obj => `${obj[fieldName]}`),
      // There are only 210 DMAs, so a capped request drops markets that have delivery.
      mapScale === BASE_MAP_SCALES.DMA ? Infinity : limit,
    ),
  };
};

export const getCongressionalBoundariesRequestBody = (mapScale, geoData, limit = 100) => {
  if (!geoData?.length) return;
  const fieldName = BeeswaxReportProperties.GEO_CONGRESSIONAL_DISTRICTS;
  return {
    mapScale,
    geoIds: dedupeAndCap(
      geoData
        .filter(obj => obj[fieldName] && obj[fieldName] !== 'Unknown')
        .flatMap(obj =>
          obj[fieldName].split('|').map((val = '') =>
            val
              .trim()
              .split('-')
              .map((str, i) => (!i ? str : str.padStart(2, '0')))
              .join(''),
          ),
        ),
      limit,
    ),
  };
};
